import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { baseUrl } from 'utils/axios'
import { handleErrors } from 'utils/helpers'
import { IPaginatedResponse } from 'types/api/general.interface'
import {
  IAssignmentsState,
  IGetAssignmentsParams,
  IOperationalAssignment,
} from './assignments.types'

const initialState: IAssignmentsState = {
  data: [],
  totalCount: 0,
  totalPages: 0,
  isLoading: false,
}

export const getOperationalAssignments = createAsyncThunk(
  'assignments/getList',
  async (params: IGetAssignmentsParams, thunkAPI) => {
    try {
      const resp: AxiosResponse<IPaginatedResponse<IOperationalAssignment>> = await baseUrl.get(
        'operational/management/assignment',
        { params },
      )
      return resp.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

export const getUserCurrentAssignment = createAsyncThunk(
  'assignments/getUserCurrent',
  async (userId: number, thunkAPI) => {
    try {
      const resp: AxiosResponse<IPaginatedResponse<IOperationalAssignment>> = await baseUrl.get(
        'operational/management/assignment',
        { params: { page: 1, limit: 5, userIds: String(userId) } },
      )
      return resp.data.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

const assignmentsSlice = createSlice({
  name: 'assignments',
  initialState,
  reducers: {
    clearAssignments: () => initialState,
  },
  extraReducers: {
    [getOperationalAssignments.pending.type]: (state) => {
      state.isLoading = true
    },
    [getOperationalAssignments.fulfilled.type]: (
      state,
      { payload }: { payload: IPaginatedResponse<IOperationalAssignment> },
    ) => {
      state.isLoading = false
      state.data = payload.data
      state.totalCount = payload.totalCount
      state.totalPages = payload.totalPages
    },
    [getOperationalAssignments.rejected.type]: (state, { payload }) => {
      state.isLoading = false
      handleErrors(payload)
    },
  },
})

export const { clearAssignments } = assignmentsSlice.actions
export default assignmentsSlice.reducer
